import {$delete, $fetch, $post} from '@/services';

export function fetch(data) {
  return $fetch(`/customer/identification/search`, data);
}

export function getOne(id, data) {
  return $fetch(`/customer/identification/${id}`, data);
}

export function post(data) {
  return $post(`/customer/identification`, data);
}

export function remove(id) {
  return $delete(`/customer/identification/${id}`);
}

// steps
export function profile(data) {
  return $post(`/customer/identification/profile`, data);
}

export function knowledge(data) {
  return $post(`/customer/identification/knowledge`, data);
}

export function assess(data) {
  return $post(`/customer/identification/assess`, data);
}

export function experience(data) {
  return $post(`/customer/identification/experience`, data);
}

export function employment(data) {
  return $post(`/customer/identification/employment`, data);
}

export function finance(data) {
  return $post(`/customer/identification/finance`, data);
}

export function trading(data) {
  return $post(`/customer/identification/trading`, data);
}

export function tradingConsent(data) {
  return $post(`/customer/identification/tradingConsent`, data);
}
